import { ConsoleRequest, DataProviderEntity, DataProviderType } from './request';
import { GetCompanyPackagesResponse, GetPackageByIdResponse } from '../response';

export class Packages {
  static async getCompanyPackages(companyId: string): Promise<GetCompanyPackagesResponse> {
    return await ConsoleRequest.createRequest<GetCompanyPackagesResponse>({
      dataProviderType: DataProviderType.CORE,
      payload: { companyId: companyId },
      endpoint: Packages.endpoint,
      method: Packages.EndpointMethod.GET_COMPANY_PACKAGES,
    });
  }

  static async getPackageById(payload: GetPackageByIdPayload): Promise<GetPackageByIdResponse> {
    return await ConsoleRequest.createRequest<GetPackageByIdResponse>({
      dataProviderType: DataProviderType.CORE,
      dataProviderEntity: DataProviderEntity.MODEL,
      endpoint: Packages.endpoint,
      method: Packages.EndpointMethod.GET_PACKAGE_BY_ID,
      payload: payload,
    });
  }
}

export namespace Packages {
  export const endpoint = 'Packages';

  export enum Types {
    SVA = 3,
    Endpoints = 4, // BEST
    Sandbox = 5, // Sandbox Security Appliance
    Ghostr = 6, // Ghostr Network Sensor
    Frat = 7,
    RelayForFrat = 8,
  }
  export enum EndpointMethod {
    READ_RECORDS = 'readRecords',
    CREATE_RECORDS = 'createRecords',
    UPDATE_RECORDS = 'updateRecords',
    REMOVE_RECORDS = 'removeRecords',
    GET_PACKAGE_LINKS = 'getPackageLinks',
    SEND_LINKS_BY_EMAIL = 'sendLinksByEmail',
    GET_PACKAGE_BY_ID = 'getPackageById',
    GET_COMPANY_PACKAGES = 'getCompanyPackages',
  }
}

export interface GetPackageByIdPayload {
  id: string;
  type: Packages.Types;
}
